<template>
    <div class="xes-question-assembly">
        <!-- 左侧操作区 -->
        <div class="assembleLeft">
            <!-- :class="{'left-fixed':leftFixedTop}" -->
            <div class="assembleLeft_operate">
                <slot name="assemblyButtons" :data="assemblyData"></slot>
            </div>
            <!-- 内容配置项 -->
            <leftOption v-if="ispaperconfig"></leftOption>
            <!-- 试题统计项 -->
            <leftStatistics ref="leftStatistics" :left_fixed="left_fixed" @toScroll="toScroll" :scrollTop="scrollTop" @delEmpty="delEmpty">
                <template slot="leftGroupButtons" slot-scope="{data,index}">
                    <slot name="leftGroupButtons" :data="data" :index="index"></slot>
                </template>
            </leftStatistics>
        </div>
        <!-- 右侧试卷内容 -->
        <div class="assembleRight" ref="right">
            <div class="assembleMain" v-if="segment_list.length">
                <!-- 试卷头部信息 -->
                <mainInfo :title_edit="title_edit" :department_name="department_name" :subject_name="subject_name"></mainInfo>
                <!-- 试卷内容 -->
                <mainGroup :title_edit="title_edit" :question_options="question_options" :question_mode="question_mode" :question_expand="question_expand" :question_operatingfloat="question_operatingfloat" @delEmpty="delEmpty"></mainGroup>
            </div>
            <div class="nodata" v-else-if="!this.loading">
                <div class="nodatapic"></div>
                <!-- <img :src="nodatapic" /> -->
                <p>您的查询结果无内容</p>
            </div>
        </div>
        <!-- 设置分数 -->
        <setScore :scoretype="scoretype" v-if="segment_list.length"></setScore>
        <!-- 转出 -->
        <el-dialog :append-to-body="true" v-if="questionTransferOut" :visible.sync="questionTransferOut" custom-class="questionTransfer xes-dialog" top="0" title="转移试题" :close-on-press-escape="false" :close-on-click-modal="false">
            <questionTransferOut></questionTransferOut>
        </el-dialog>
        <!-- 转入 -->
        <el-dialog :append-to-body="true" v-if="questionTransferEnter" :visible.sync="questionTransferEnter" custom-class="questionTransfer xes-dialog" top="0" title="转移试题" :close-on-press-escape="false" :close-on-click-modal="false">
            <questionTransferEnter></questionTransferEnter>
        </el-dialog>
        <toTop></toTop>
    </div>
</template>
<script>
import leftOption from './leftOption'//内容筛选项
import leftStatistics from './leftStatistics'//内容统计项
import mainInfo from './mainInfo'//试卷头部信息
import mainGroup from './mainGroup'//试卷内容
import $store from '../store'
import setScore from './setScore'//设置得分
import questionTransferOut from './questionTransferOut'//试题转出
import questionTransferEnter from './questionTransferEnter'//试题转入
import toTop from './toTop'//置顶按钮
import { httpRequest } from '../../../src/utils/ajax'
import utils from './utils'
export default {
    props:{
        id: {//id
            type: [String,Number],
            default: 0
        },
        paramsbyid: {//请求参数
            type: Object,
            default: function(){
                return {}
            }
        },
        paramsbylocal: {//请求参数
            type: Object,
            default: function(){
                return {}
            }
        },
        actionbyid: {//请求地址
            type: String,
            required: true
        },
        actionbylocal: {//请求地址
            type: String
        },
        department_name: {
            type: String,
            default: ''
        },
        subject_name: {
            type: String,
            default: ''
        },
        ispaperconfig: {
            type:Boolean,
            default:false
        },
        paper_config:{
            type:Object,
            default:function(){
                return {
                    title: 1, //显示主标题：1 显示  0 不显示
                    subtitle: 0, //显示副标题： 1 显示  0 不显示
                    student: 0, //显示考生信息: 1 显示  0 不显示
                    notice: 0, //显示注意事项: 1 显示  0 不显示
                    segment: 1, //显示分大题: 1 显示  0 不显示
                    segmentmemo: 1 //显示大题注释: 1 显示  0 不显示
                }
            }
        },
        local_name: {
            type: String,
            default: 'assemblyData'
        },
        left_fixed: {
            type: Boolean,
            default: false
        },
        question_options: {
            type: Object,
            default: function(){
                return {}
            }
        },
        question_mode: {
            type: String,
            default: 'common'
        },
        question_expand: {
            type: Boolean,
            default: false
        },
        question_operatingfloat: {
            type: Boolean,
            default: true
        },
        title_edit: {
            type: Object,
            default:{}
        },
        scoretype: {
            type: String,
            default: 'int'
        }
    },
    name:'xes-question-assembly',
    components: {
        leftOption,
        leftStatistics,
        mainInfo,
        mainGroup,
        setScore,
        questionTransferOut,
        questionTransferEnter,
        toTop
    },
    data () {
        return {
            scrollTop:0,//滚动高度
            loading:null,
        }
    },
    methods: {
        delEmpty(){
            this.$emit('delEmpty')
        },
        clearAssembly(cb){//放弃修改
            let tit = `确认放弃组卷（ id:${this.assemblyData.id} ）的修改？`
            this.$msgBox.delDialog(tit,()=>{
                $store.commit('CLEARASSEMBLYSTATE')
                cb&&cb()
            })
        },
        getData(){//获取本地组卷数据
            return this.assemblyData
        },
        toScroll(){//试卷定位
            $store.commit('SETSCROLLTIMER',{fn:this.setScroll})
        },
        setScroll(){//定位动画
            if(this.currentNode.length == 1){//选中题组时
                var aims = this.$el.querySelector('#group'+this.currentNode[0]).offsetTop
            }
            if(this.currentNode.length == 2){//选中单题时
                var two = this.currentNode[1]
                var aims = this.$el.querySelector('#questions'+this.currentNode[0]+two).offsetTop
            }
            var maxScoll = document.documentElement.scrollHeight - document.body.clientHeight
            aims = aims<maxScoll?aims:maxScoll
            
            var curHeight = document.documentElement.scrollTop || document.body.scrollTop;
            var now = curHeight;
            var speed = (aims > now) ? Math.ceil((aims - now) / 5) : Math.floor((aims - now) / 5);
            if (curHeight === aims) {
                $store.commit('SETSCROLLTIMER')
            }
            document.documentElement.scrollTop = curHeight + speed;
            document.body.scrollTop =  curHeight + speed;
        },
        setStoreData(){
            $store.commit('SETASSEMBLYSTATE',{name:'local_name',value:this.local_name})
            $store.commit('RENEWASSEMBLESTORE',{type:1,name:'name',value:utils.storage(this.local_name)&&utils.storage(this.local_name).name || ''})
            $store.commit('RENEWASSEMBLESTORE',{type:1,name:'department',value:utils.storage(this.local_name)&&utils.storage(this.local_name).department || ''})
            $store.commit('RENEWASSEMBLESTORE',{type:1,name:'grade_id',value:utils.storage(this.local_name)&&utils.storage(this.local_name).grade_id || ''})
            $store.commit('RENEWASSEMBLESTORE',{type:1,name:'subject_ids',value:utils.storage(this.local_name)&&utils.storage(this.local_name).subject_ids || []})
            $store.commit('RENEWASSEMBLESTORE',{type:1,name:'paper_type',value:utils.storage(this.local_name)&&utils.storage(this.local_name).paper_type|| 1})
            $store.commit('RENEWASSEMBLESTORE',{type:1,name:'test_type',value:utils.storage(this.local_name)&&utils.storage(this.local_name).test_type || ''})
            $store.commit('RENEWASSEMBLESTORE',{type:1,name:'paper_time',value:utils.storage(this.local_name)&&utils.storage(this.local_name).paper_time || ''})
            $store.commit('RENEWASSEMBLESTORE',{type:1,name:'sub_title',value:utils.storage(this.local_name)&&utils.storage(this.local_name).sub_title || ''})
            $store.commit('RENEWASSEMBLESTORE',{type:1,name:'notice',value:utils.storage(this.local_name)&&utils.storage(this.local_name).notice || '请填写注意事项'})
            $store.commit('RENEWASSEMBLESTORE',{type:1,name:'segment_list',value:utils.storage(this.local_name)&&utils.storage(this.local_name).segment_list || []})

            $store.commit('RENEWASSEMBLESTORE',{type:1,name:'id',value:this.id})//跟新store中id的值
            $store.commit('RENEWASSEMBLESTORE',{type:1,name:['options','struct_title'],value:utils.storage(this.local_name)&&utils.storage(this.local_name).options.struct_title||this.paper_config.title})
            $store.commit('RENEWASSEMBLESTORE',{type:1,name:['options','struct_subtitle'],value:utils.storage(this.local_name)&&utils.storage(this.local_name).options.struct_subtitle||this.paper_config.subtitle})
            $store.commit('RENEWASSEMBLESTORE',{type:1,name:['options','struct_student'],value:utils.storage(this.local_name)&&utils.storage(this.local_name).options.struct_student||this.paper_config.student})
            $store.commit('RENEWASSEMBLESTORE',{type:1,name:['options','struct_notice'],value:utils.storage(this.local_name)&&utils.storage(this.local_name).options.struct_notice||this.paper_config.notice})
            $store.commit('RENEWASSEMBLESTORE',{type:1,name:['options','struct_segment'],value:utils.storage(this.local_name)&&utils.storage(this.local_name).options.struct_segment||this.paper_config.segment})
            $store.commit('RENEWASSEMBLESTORE',{type:1,name:['options','struct_segmentmemo'],value:utils.storage(this.local_name)&&utils.storage(this.local_name).options.struct_segmentmemo||this.paper_config.segment?this.paper_config.segmentmemo:false})
            $store.commit('SAVEASSEMBLESTORE')
        },
        getSegmentList(){
            if(this.id && this.assemblyData.segment_list.length == 0 || !this.actionbylocal){
                var option = {
                    method: "POST",
                    params: this.paramsbyid,
                    action: this.actionbyid
                }
            }else{
                var option = {
                    method: "POST",
                    params: {form:JSON.stringify({segment_list:this.assemblyData.segment_list}),...this.paramsbylocal},
                    action: this.actionbylocal
                }
            }
            this.$emit('ajax-before',option)
            this.loading = this.$loading({
                background: 'rgba(255, 255, 255, 0.5)'
            });
            httpRequest(option).then(res => {
                this.loading.close()
                this.loading = null
                if (res.status == 100) {
                    this.$emit('ajax-success',res)
                    if(this.id && this.assemblyData.segment_list.length == 0 || !this.actionbylocal){
                        $store.commit('RENEWASSEMBLESTOREBYID',res.data)
                        $store.commit('GETPAPERBYSTORAGE',res.data)
                    }else{
                        if(option.params.is_repeat == 1){
                            $store.commit('RENEWASSEMBLELISTSTOREBYID',res.data)
                        }
                        $store.commit('GETPAPERBYSTORAGE',res.data)
                    }
                }else{
                    this.$emit('ajax-error',res)
                }
            }).catch(err => {
                this.loading.close()
                this.loading = null
                this.$emit('ajax-error',err)
            })
        }
    },
    computed:{
        assemblyData(){
            return $store.state.assemblyData
        },
        currentNode(){
            return $store.state.currentNode
        },
        segment_list(){
            return $store.state.segment_list
        },
        questionTransferOut:{//试题转移视图
            set(){
                $store.commit('SETQUESTIONTRANSFERSHOW')
            },
            get(){
                return $store.state.questionTransferOutShow
            }
        },
        questionTransferEnter:{//试题转移视图
            set(){
                this.transferList = []
                $store.commit('SETTRANSFERTESTSHOW')
            },
            get(){
                return $store.state.questionTransferEnterShow
            }
        },
        leftFixedTop(){
            if(this.$refs.leftStatistics){
                let top = this.$refs.leftStatistics.$el.offsetTop
                return this.scrollTop > top && this.left_fixed
            }
            return this.scrollTop > 100 && this.left_fixed
        }
    },
    mounted () {
        this.setStoreData()
        this.getSegmentList()
        window.onscroll = () => {//监听scroll事件
            this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        }
        window.addEventListener("storage", e => {//监听storage，跟新数据
            if(e.key == this.local_name){
                $store.commit("RENEWASSEMBLY");
                this.$emit('storage-change',e.newValue,e.oldValue)
            }
        })
        document.onmousedown = function(e) {
            var target = e.target || e.srcElement;
            if (target.nodeName.toLowerCase() == "img") {
                target.draggable = false
            }
        };
    }
}
</script>



// WEBPACK FOOTER //
// packages/question-assembly/src/index.vue